import MasterTab from 'src/components/Layouts/MasterTab.vue';
import CompetencyMatriz from "src/views/Pages/Dashboard/Grow/Reports/CompetencyMatriz/CompetencyMatriz.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const CompetencyMatrizRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'competencymatrizreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.competency_matriz_report',
          component: CompetencyMatriz,
          meta: {
            prefix_permission: 'grow_competencymatrizreport',
          },
        },
      ],
    },
  ],
};

export default CompetencyMatrizRoutes;